import { apiContainer, queryBuilder } from './apiContainer'

const SLICE_API_ROOT = '/industries'

const industryApi = apiContainer.injectEndpoints({
  endpoints: build => ({
    listIndustries: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args),
      keepUnusedDataFor: 86400
    }),
    getOneIndustry: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args),
      keepUnusedDataFor: 86400
    })
  }),
  overrideExisting: true
})

export const { useLazyListIndustriesQuery } = industryApi
